import { memoize } from 'lodash';
import { get } from '../../common/httpService';
const fallbackOfferData = {
    hexColorTopRight: 'gray',
    hexColorBottomLeft: 'white',
    labelColor: 'black',
    labelColorHover: 'black',
    labelText: 'promo',
};

const getActiveOffersTag = async ({ offerdata }) => {
    try {
        if (offerdata) {
            let {
                hexColorTopRight,
                hexColorBottomLeft,
                labelColor,
                labelColorHover,
                labelText,
            } = JSON.parse(offerdata);

            return {
                hexColorTopRight,
                hexColorBottomLeft,
                labelColor,
                labelColorHover,
                labelText,
            };
        } else {
            const obj = await memoActiveOffersTag();
            return obj;
        }
    } catch (error) {
        console.error('Error on offerTags on ProductTags', error);
        return fallbackOfferData;
    }
};
const memoActiveOffersTag = memoize(
    async () => await get({ url: `Tag/getActiveOffersTag` })
);
export { getActiveOffersTag, fallbackOfferData };
